import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/packages/frontend-bo/src/layouts/default.vue").then(m => m.default || m))
}